module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDoelstellingenA1BD39.85f75c5c.png";